import Api from './Api';

export default{
    create(infoData){
        return Api.post('/customerContact', infoData)
    },
    read(){
        return Api.get('/auth/customerContact')
    },
    delete(id){
        return Api.delete(`/auth/customerContact/${id}`)
    }
}